export default __webpack_public_path__ + "static/media/Basics Computer Application Certificate.32667f06.JPG";